import { useBreadcrumb } from '../../hooks/useBreadcrumb';
import { Template } from './Template';

export type BreadCrumbProps = { className?: string };

export const BreadCrumb: React.FC<BreadCrumbProps> = ({ className }) => {
	const items = useBreadcrumb();

	if (items.length <= 0) {
		return null;
	}

	return (
		<Template
			items={items}
			className={`header-bread-crumb${className ? ` ${className}` : ''}`}
		/>
	);
};
